__turbopack_context__.v({
  "baseRotate": "Orbit-module__qxbY4G__baseRotate",
  "core": "Orbit-module__qxbY4G__core",
  "particle": "Orbit-module__qxbY4G__particle",
  "root": "Orbit-module__qxbY4G__root",
  "rotating": "Orbit-module__qxbY4G__rotating",
  "stage": "Orbit-module__qxbY4G__stage",
});
